module.exports = __webpack_public_path__ + "static/wifi-e3a5e77cf19219496e5a571edd35cb9e.png";